"use client";

import { ArrowRight, Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ResultadosQueHablanPorSSolos() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="3056" id="resultados-que-hablan-por-sí-solos" className="relative min-h-[90vh] w-full overflow-hidden bg-secondary text-secondary-foreground dark">
      {}
      <div className="absolute inset-0 z-0 opacity-10">
        <div className="absolute inset-0" style={{
        backgroundImage: `radial-gradient(circle at 2px 2px, var(--primary) 1px, transparent 0)`,
        backgroundSize: '40px 40px'
      }} />
      </div>

      {}
      <svg className="absolute -bottom-24 -left-24 size-[600px] opacity-5" viewBox="0 0 100 100" fill="none">
        <path d="M0 100 C 20 0, 80 0, 100 100" stroke="currentColor" strokeWidth="0.5" />
      </svg>

      {}
      <div className="absolute top-12 left-12 z-20 font-mono text-[10px] tracking-widest opacity-20 md:top-14 md:left-14">&nbsp;</div>

      <div className="relative z-10 mx-auto grid min-h-[90vh] max-w-1440 px-[5%] lg:grid-cols-12">
        {}
        <div className="flex flex-col justify-center py-24 lg:col-span-7 lg:pr-12">
          <div ref={contentRef} className={`transition-all duration-1000 cubic-bezier(0.16, 1, 0.3, 1) ${contentVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            {}
            <div className="relative mb-8 pl-6">
              
              <span className="font-default text-xs font-bold uppercase tracking-[0.2em] text-primary"></span>
            </div>

            <h1 className="font-default text-[clamp(2.5rem,5vw,4.5rem)] font-semibold leading-[1.1] tracking-tighter text-border">
              Resultados que <br />
              <span className="text-border">hablan por sí solos</span>
            </h1>

            <p className="mt-8 max-w-xl font-default text-lg leading-relaxed !font-medium md:text-xl text-chart-3">
              Medicina y cirugía capilar de alta precisión, donde la ciencia se encuentra con la naturalidad para restaurar no solo tu cabello, sino tu confianza.
            </p>

            <div className="mt-12 flex flex-wrap gap-6">
              <Link to="/ContactPage">
                <Button size="lg" className="h-14 bg-primary px-10 font-default text-sm font-bold uppercase tracking-wider text-white transition-all hover:bg-secondary hover:ring-1 hover:ring-primary">
                  Solicitar Consulta
                  <ArrowRight className="ml-2 size-4" />
                </Button>
              </Link>
              <Link to="/DrSotoPage">
                <Button variant="outline" size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive border shadow-xs rounded-md has-[>svg]:px-4 h-14 border-primary px-10 font-default text-sm font-bold uppercase tracking-wider !opacity-[1] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 dark:bg-input/30 dark:border-input dark:hover:bg-input/50 hover:bg-primary hover:text-white bg-border text-border">
                  Conoce a la Dra. Soto
                </Button>
              </Link>
            </div>
          </div>
        </div>

        {}
        <div className="relative hidden lg:col-span-5 lg:block">
          <div className="absolute inset-0 overflow-hidden">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/success_stories_hero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/success_stories_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/success_stories_hero.png-wvc-sizes" alt="Clinical Excellence" className="h-full object-cover grayscale-[0.2] transition-transform duration-[2000ms] !w-[650px] hover:scale-105" loading="lazy" src="https://msinstitutocapilar.com/wp-content/uploads/2026/07/WhatsApp-Image-2026-06-27-at-10.50.26-7.jpeg" />
            {}
            <div className="absolute inset-0 bg-secondary/20 mix-blend-multiply" />
            <div className="absolute inset-0 bg-gradient-to-r from-secondary via-transparent to-transparent" />
          </div>

          {}
          <Plus className="absolute top-12 right-12 size-6 text-primary/40" strokeWidth={1} />
          <Plus className="absolute bottom-12 right-12 size-6 text-primary/40" strokeWidth={1} />
          
          {}
          
        </div>
      </div>

      {}
      <div className="relative h-64 w-full lg:hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/success_stories_hero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/success_stories_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/success_stories_hero.png-wvc-sizes" alt="Clinical Excellence" className="h-full w-full object-cover grayscale-[0.2]" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-t from-secondary to-transparent" />
      </div>
    </section>;
}